// -------------------------------------------------------------------------------
// Libraries
// -------------------------------------------------------------------------------
import React, { useCallback, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';

// -----------------------------------------------------------------------------
// Store
// -----------------------------------------------------------------------------
import { useGetRowsQuery } from '../../store/queries/rows';

// -----------------------------------------------------------------------------
// Components
// -----------------------------------------------------------------------------
import { RowCard } from '../../components/row-card';
import { MusicPlayerRow } from '../../components/music-player-row';

// -----------------------------------------------------------------------------
// Styles
// -----------------------------------------------------------------------------
import StyledHomePage from './styles';

// -------------------------------------------------------------------------------
// Component
// -------------------------------------------------------------------------------
const HomePage = () => {
  const [track, setTrack] = useState(null);
  const [firstLoad, setFirstLoad] = useState(true);
  const { data, isLoading } = useGetRowsQuery();

  const setLocalTrack = useCallback((data, first) => {
    setTrack(data);
    setFirstLoad(first);
  }, []);

  return (
    <StyledHomePage>
      <div className="fr-home-page">
        {isLoading && (
          <div className="fr-home-page__loading-container">
            <LoadingOutlined spin />
          </div>
        )}
        {!isLoading && data && (
          <div className="fr-home-page__cards">
            {data.musicrows.map((item, index) => (
              <RowCard
                key={`rows-item-${index}`}
                rowData={item}
                index={index}
                length={data.musicrows.length}
                setTrack={setLocalTrack}
              />
            ))}
          </div>
        )}
        <div className="fr-home-page__player">
          <MusicPlayerRow track={track} firstLoad={firstLoad} />
        </div>
      </div>
    </StyledHomePage>
  );
};

export default HomePage;
